/** Shared profile / AmmoScore tier helpers — single source for profile surfaces. */

export type AmmoTierName =
  | 'Newcomer'
  | 'Enthusiast'
  | 'Contributor'
  | 'Expert'
  | 'Curator'
  | 'Armorer'

export const TIER_THRESHOLDS: Array<{ name: AmmoTierName; min: number; color: string }> = [
  { name: 'Newcomer', min: 0, color: '#8B949E' },
  { name: 'Enthusiast', min: 10, color: '#58A6FF' },
  { name: 'Contributor', min: 50, color: '#3FB950' },
  { name: 'Expert', min: 100, color: '#C9A84C' },
  { name: 'Curator', min: 200, color: '#E85D04' },
  { name: 'Armorer', min: 500, color: '#F85149' }
]

export const TIER_BORDER: Record<string, string> = Object.fromEntries(
  TIER_THRESHOLDS.map((t) => [t.name, t.color])
)

export const TOP_TIER_NAMES = new Set<AmmoTierName>(['Armorer', 'Curator'])

export function getProfileInitials (
  displayName?: string | null,
  username?: string | null
): string {
  const name = (displayName || username || '?').trim()
  const parts = name.split(/\s+/)
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

export function getTierInfo (score: number) {
  let current = TIER_THRESHOLDS[0]
  let next: (typeof TIER_THRESHOLDS)[number] | null = null
  for (let i = 0; i < TIER_THRESHOLDS.length; i++) {
    if (score >= TIER_THRESHOLDS[i].min) {
      current = TIER_THRESHOLDS[i]
      next = TIER_THRESHOLDS[i + 1] ?? null
    }
  }
  const progress = next
    ? Math.min(100, Math.round(((score - current.min) / (next.min - current.min)) * 100))
    : 100
  return { current, next, progress }
}

/** Secondary profile action button (Edit Profile, Follow, overflow menu trigger). */
export const PROFILE_ACTION_BUTTON_SX = {
  background: 'var(--gs-surface2)',
  border: '1.5px solid var(--gs-border-bright)',
  color: 'var(--gs-text)',
  padding: '7px 14px',
  borderRadius: 5,
  fontSize: 12,
  cursor: 'pointer' as const,
  fontFamily: 'DM Sans, sans-serif'
}

export const PROFILE_ACCENT_BUTTON_SX = {
  ...PROFILE_ACTION_BUTTON_SX,
  background: 'var(--gs-accent)',
  borderColor: 'var(--gs-accent)',
  color: '#fff'
}
